import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/pro-regular-svg-icons";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { LocationButtonProps } from "../../../../interfaces/props/SaudeBemEstar/PalestrasEventos/LocationButtonProps";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { sxButton, sxTextButton } from "../sxProps";

export const LocationButton: React.FC<LocationButtonProps> = ({ evento }) => {
  const { buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();

  const address = evento?.complementos?.[0]?.valor;
  const title = evento?.tipoEvento === "P" ? "VER NO MAPA" : "INGRESSAR NO EVENTO";
  const startIcon = evento?.tipoEvento === "P" ? <FontAwesomeIcon style={buttonTextStyleAccessibility} icon={faLocationDot} color="white" /> : undefined;
  const ariaLabel = evento !== null && (evento.tipoEvento === "P" 
    ? `Ver no mapa local do evento ${evento.titulo}, agendado para ${evento.data} as ${evento.hora}, sobre ${evento.descr}`
    : `Ingressar em ${evento.titulo}, agendado para ${evento.data} as ${evento.hora}, sobre ${evento.descr}, que será ${evento.tipoEvento}`)

  const onClick = () => {
    if (evento?.tipoEvento === "P") window.open(`http://maps.google.com/?q=${address}`, "_blank");
    else window.open(address, "_blank");
  };

  if (!address) return <></>;

  return (
    <Button 
      className="invitation-card-action-button" 
      variant="contained" 
      style={buttonStyleAccessibility} 
      sx={sxButton} 
      startIcon={startIcon} 
      onClick={onClick}
      tabIndex={0}
      aria-label={ariaLabel || ''}
      >
        <Typography style={buttonTextStyleAccessibility} sx={sxTextButton}>
          {title}
        </Typography>
    </Button>
  );
};
